module.exports = __webpack_public_path__ + "img/Transpordiamet_icon_white.411dc354.svg";